export const AuthOperationEnum = Object.freeze({
	LOGIN: 'login',
	INITIALIZE: 'initialize',
	LOGOUT: 'logout',
	SELECT: 'select',
	REFRESH: 'refresh',
})
